<template>
  <!-- <div class="right-float"> -->
  <div >
    <Form label-position="right" :label-width="100">
      <Row >

        <Col :xs="12" :sm="12" :md="6">
          <FormItem prop="user" label="课顾分组：" >
            <Select v-model="teamType" :disabled="adviserGroupSelectDisable" @on-change="onTeamTypeChange">
              <Option v-for="item in adviserGroupList" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>

        <Col :xs="12" :sm="12" :md="6">
          <FormItem prop="password" label="课程顾问：" >
            <Select v-model="adviserId" :disabled="adviserSelectDisable" @on-change="onAdviserIdChange">
              <Option value="0">不论</Option>
              <Option v-for="item in adviserList" :value="item.adviserId" :key="item.adviserId">{{
                  item.adviserName
                }}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  name: 'AdviserFloatModal',
  props: {},
  data () {
    let $constant = this.$constant
    return {
      adviserId: null,
      teamType: 0,
      adviserSelectDisable: true,
      adviserGroupSelectDisable: true,
      adviserGroupList: $constant.adviserGroup,
      adviserList: [],
      adviserIdList: [],
    }
  },
  methods: {
    getAdviserList (teamType, adviserId, positionType) {
      let self = this
      self.adviserIdList = []
      if (positionType === 1) {
        self.adviserIdList.push(adviserId)
        self.$emit('get_adviser', {adviserId: adviserId, teamType: teamType, adviserIds: self.adviserIdList})
      } else {
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.adviserList = res.data
            if (adviserId > 0) {
              self.adviserIdList.push(adviserId)
            } else {
              for (let i in self.adviserList) {
                self.adviserIdList.push(self.adviserList[i].adviserId)
              }
            }
            self.$emit('get_adviser', {adviserId: adviserId, teamType: teamType, adviserIds: self.adviserIdList})
          }
        })
      }
    },
    onTeamTypeChange (value) {
      let self = this
      self.adviserId = null
      self.adviserIdList = []
      self.getAdviserList(value, 0, null)
    },
    onAdviserIdChange (value) {
      if (value === null) {
        return
      }
      let self = this
      self.adviserIdList = []
      if (value > 0) {
        self.adviserIdList[0] = value
      } else if (value === '0') {
        for (let i in self.adviserList) {
          self.adviserIdList.push(self.adviserList[i].adviserId)
        }
      }
      self.$emit('get_adviser', {adviserId: value, teamType: self.teamType, adviserIds: self.adviserIdList})
    }
  },
  watch: {},
  created: function () {
    let permissions = this.$store.get('permissions')
    if (permissions.indexOf('all') >= 0) {
      this.adviserGroupSelectDisable = false
      this.adviserSelectDisable = false
      this.teamType = 0
      this.adviserId = 0
      this.getAdviserList(this.teamType, this.adviserId, null)
    } else if (this.$store.get('adviserInfo')) {
      this.adviserGroupSelectDisable = this.$store.get('adviserInfo').positionType !== 9
      this.adviserSelectDisable = this.$store.get('adviserInfo').positionType === 1
      this.teamType = this.$store.get('adviserInfo').teamType
      this.adviserList[0] = this.$store.get('adviserInfo')
      this.adviserId = this.$store.get('adviserInfo').adviserId
      this.getAdviserList(this.teamType, this.adviserId, this.$store.get('adviserInfo').positionType)
    }
  },
}
</script>





// WEBPACK FOOTER //
// AdviserFloatModal.vue?2ac12324